import { render, staticRenderFns } from "./loginWithWechat.vue?vue&type=template&id=9770d38c&"
import script from "./loginWithWechat.vue?vue&type=script&lang=ts&"
export * from "./loginWithWechat.vue?vue&type=script&lang=ts&"
import style0 from "./loginWithWechat.vue?vue&type=style&index=0&id=9770d38c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports